import { render, staticRenderFns } from "./iframe_mod.vue?vue&type=template&id=f5e2954e"
import script from "./iframe_mod.vue?vue&type=script&lang=js"
export * from "./iframe_mod.vue?vue&type=script&lang=js"
import style0 from "./iframe_mod.vue?vue&type=style&index=0&id=f5e2954e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports